import { supabase } from "@/integrations/supabase/client";

const BUCKET = "catalogs";
const FILE_NAME = "catalog.pdf";

/** Public URL of the business catalog PDF managed from the admin panel. */
export const CATALOG_URL =
  supabase.storage.from(BUCKET).getPublicUrl(FILE_NAME).data.publicUrl;
